// extracted by mini-css-extract-plugin
module.exports = {"root":"FavoritesButton_root__1C5g8","addIcon":"FavoritesButton_addIcon__1cggt","removeIcon":"FavoritesButton_removeIcon__2cdqk","text":"FavoritesButton_text__1AtAw"};